import { Slider, styled } from 'components/Material/index'

export const DoubleSlider = styled(Slider)(() => ({
  color: '#1856ff',
  maxWidth: '95%',
  height: 6,
  '& .MuiSlider-thumb': {
    height: 20,
    width: 20,
    backgroundColor: '#1856ff',
    border: '2px solid currentColor',
    marginTop: -2,
    marginLeft: -6,
    '&:focus, &.Mui-active': {
      boxShadow: 'inherit'
    },
    '&:hover': {
      boxShadow: '0px 0px 0px 8px rgba(24, 86, 255, 0.16)'
    }
  },
  '& .MuiSlider-track': {
    height: 4,
    borderRadius: 4,
    backgroundColor: '#1856ff'
  },
  '& .MuiSlider-rail': {
    height: 4,
    borderRadius: 4
  }
}))
